import isEqual from "lodash/isEqual";

import { getListVisibleSorts, useListContext } from "@/modules/list";

export const useListResetActions = () => {
  const {
    filters,
    visibleSort,
    defaultSort,
    columnsOptions,
    clearFiltersAndSorts,
    resetFiltersAndSorts,
  } = useListContext();

  const visibleDefaultSort = getListVisibleSorts({
    sort: defaultSort,
    columns: columnsOptions,
  });

  const hasFilters = Object.keys(filters).length > 0;
  const hasSorts = visibleSort.length > 0;

  const isDefaultSort = isEqual(visibleSort, visibleDefaultSort);
  const isDefaultState = isDefaultSort && !hasFilters;

  const noFilterSort = !hasFilters && !hasSorts;

  const onResetClick = () => {
    resetFiltersAndSorts();
  };

  const onDeleteClick = () => {
    clearFiltersAndSorts();
  };

  return {
    resetButton: {
      onClick: onResetClick,
      disabled: isDefaultState,
    },
    deleteButton: {
      onClick: onDeleteClick,
      disabled: noFilterSort,
    },
  };
};
